import React from 'react'
import { useLocation } from 'react-router-dom'

const CommonItemFlag = ({ isListed, isMine }) => {

  const { pathname } = useLocation();

  if (isListed === false && isMine === false && pathname.includes('/marketplace')) {
    return <span className='cards-list__block-item-tag cards-list__block-item-tag--not-listed'>Not Listed</span>
  } else if ((isListed && isMine) || (pathname.includes('/myhub') && isListed)) {
    return <span className='cards-list__block-item-tag cards-list__block-item-tag--listed'>For Sale</span>
  }
}

export default CommonItemFlag
